import { render } from "./ListaCategorias.vue?vue&type=template&id=fb5e8dac&scoped=true"
import script from "./ListaCategorias.vue?vue&type=script&lang=js"
export * from "./ListaCategorias.vue?vue&type=script&lang=js"

import "./ListaCategorias.vue?vue&type=style&index=0&id=fb5e8dac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb5e8dac"]])

export default __exports__